module.exports = __webpack_public_path__ + "img/selected_cabinet_off.d3bdeb5f.svg";